import { ReactNode } from 'react';
import AudioPlayer from '@/components/audio/AudioPlayer';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-background pb-32">
      {children}
      <AudioPlayer />
    </div>
  );
}
